import { api } from 'data/api/api'

import { ToggleUserFavouriteArgs } from '../types/toggle-favourite'

export const toggleUserFavourite = ({ entityId }: ToggleUserFavouriteArgs) =>
  api.post('/user_favourites/toggle', {
    type: 'item',
    user_favourites: [entityId],
  })
